import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import Home from "@/views/home/Home";
import Browse from "@/views/datasource/Browse";
import Download from "@/views/download/Download";
import Help from "@/views/help/Help";
import Contact from "@/views/contact/Contact";
import Detail from "@/views/search/Detail";
import Annotation from "@/views/search/Annotation";
import Search from "@/views/search/Search";
import Submit from "@/views/submit/Submit";
import Statistics from "@/views/statistics/Statistics";


Vue.use(VueRouter)

const routes = [
  {
    path:'',
    redirect:'/Home'
  },
  {
    path: "/Home",
    component:Home
  },

  {
    path: "/Browse",
    component:Browse
  },
  {
    path: "/Download",
    component:Download
  },
  {
    path: "/Help",
    component:Help
  },
  {
    path: "/Contact",
    component:Contact
  },
  {
    path: "/Detail/:input",
    component:Detail
  },

  {
    path: '/Annotation/:input',
    component: Annotation
  },

  {
    path: '/Search/',
    component: Search
  },
  {
    path: '/Submit/',
    component: Submit
  },
  {
    path: '/Statistics/',
    component: Statistics
  },

]

const router = new VueRouter({
  routes
})

const originalPush=Router.prototype.push
Router.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err => err)
}

export default router
